module.exports = __webpack_public_path__ + "img/picture15.631cddfd.png";